import { Component, Input, Optional, OnInit, ElementRef, ChangeDetectionStrategy } from '@angular/core'
import { IcosBreadcrumb } from './breadcrumb'
import { Router } from '@angular/router'
import { removeNgTag } from '../shared/utils'

@Component({
  selector: 'icos-breadcrumb-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="icos-breadcrumb__item">
      <span class="icos-breadcrumb__inner" (click)="clickHandle($event)" ref="link" role="link">
        <ng-content></ng-content>
      </span>
      <i *ngIf="root.separatorClass" [class]="'icos-breadcrumb__separator ' + root.separatorClass"></i>
      <span *ngIf="!root.separatorClass" class="icos-breadcrumb__separator">{{ root.separator }}</span>
    </span>
  `
})
export class IcosBreadcrumbItem implements OnInit {
  @Input() to: string
  @Input() prevent: boolean = false
  @Input() extras?: any

  constructor(@Optional() public root: IcosBreadcrumb, private router: Router, private el: ElementRef) {}

  clickHandle(event: Event): any {
    event.stopPropagation()
    this.root.itemHandle(this.to)
    if (!this.to || this.root.prevent || this.prevent) return
    return this.router.navigateByUrl(this.to, this.extras)
  }

  ngOnInit(): void {
    removeNgTag(this.el.nativeElement)
  }
}
